export default function Team() {
  const team = [
    {
      name: 'Robótica Industrial',
      role: 'Automatización',
      specialty: 'Sistemas de Producción',
      icon: 'ri-robot-2-line'
    },
    {
      name: 'Inteligencia Artificial',
      role: 'Machine Learning',
      specialty: 'Optimización Predictiva',
      icon: 'ri-brain-line'
    },
    {
      name: 'Ingeniería Mecánica',
      role: 'Diseño de Sistemas',
      specialty: 'Desarrollo Custom',
      icon: 'ri-settings-3-line'
    },
    {
      name: 'Gestión de Proyectos',
      role: 'Dirección Técnica',
      specialty: 'Implementación Integral',
      icon: 'ri-file-list-3-line'
    }
  ];

  return (
    <section id="team" className="relative py-16 md:py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-black overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)',
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4">
            Áreas de Especialización
          </h2>
          <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto">
            Expertos en robótica, IA y automatización industrial
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {team.map((area, index) => (
            <div
              key={index}
              className="group relative bg-gray-800/50 backdrop-blur-sm rounded-2xl overflow-hidden border-2 border-gray-700 hover:border-orange-500 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-64 md:h-80 overflow-hidden bg-gradient-to-br from-orange-500/20 to-green-500/20 flex items-center justify-center">
                <div className="w-32 h-32 md:w-40 md:h-40 flex items-center justify-center bg-gradient-to-br from-orange-500 to-green-500 rounded-full">
                  <i className={`${area.icon} text-6xl md:text-7xl text-white`}></i>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent"></div>
              </div>

              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-white mb-1">{area.name}</h3>
                <p className="text-orange-400 text-xs md:text-sm font-semibold mb-2">{area.specialty}</p>
                <p className="text-gray-400 text-xs md:text-sm mb-4">{area.role}</p>
              </div>

              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 to-green-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
